import { CommentActions, ProjectActions } from '../actions';
import { Comment } from '../stores';
import Immutable from 'seamless-immutable';

const initialState = Immutable(Comment);

export function comment(store = initialState, action) {
	switch (action.type) {
		case ProjectActions.SaveCommentAction.Failure:
		case ProjectActions.SaveCommentAction.Success: {
			return store.merge({
				isCommentAdding: false,
				isActCommentAdding: false,

			});
		}
		case ProjectActions.SaveCommentAction.Request: {
			return store.merge({
				isCommentAdding: action.payload.actElementId ? false: true,
				isActCommentAdding: action.payload.actElementId ? true : false
			});
		}
		case CommentActions.LoadCommentsByModeratorAction.Success: {
			return store.merge({ comments: action.payload });
		}
		case CommentActions.UpdateCommentAction.Success: {
			let index = store.comments.findIndex((item) => item.id === action.payload.id);
			let comments = store.getIn([ 'comments' ]);

			return store.merge({
				comments: comments.slice(0, index).concat(action.payload).concat(comments.slice(index + 1))
			});
		}
		case CommentActions.GetCommentAction.Success: {
			return store.merge({ comment: action.payload });
		}
		case CommentActions.UnloadCommentAction.Success: {
			return store.merge({ comment: null });
		}
		default: {
			return store;
		}
	}
}
